var styles = {"fontElementMap":"WJwEK","orderedlist":"m6wT9","bulletedlist":"_7lMx6","listItem":"yOyGd"};

export { styles as s };
//# sourceMappingURL=lists-48deb8af.js.map
